import { render, staticRenderFns } from "./StandAloneReset.vue?vue&type=template&id=2ddb8291"
import script from "./StandAloneReset.vue?vue&type=script&lang=js"
export * from "./StandAloneReset.vue?vue&type=script&lang=js"
import style0 from "./StandAloneReset.vue?vue&type=style&index=0&id=2ddb8291&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports